import 'scss/approval_queues/activity_feed.scss';

import classNames from 'classnames';
import * as R from 'ramda';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, {Component} from 'react';

import ActivityFeedItem from './activity_feed_item';
import ActivityBrandItem from './activity_brand_item';
import ContentMetadataCommentSourceCssClasses from './helpers';
import ContentMetadataPropType from '../../proptypes/index';
import {ENUMS} from 'js/common';

class ActivityFeedList extends Component {
    static propTypes = {
        collapseable: PropTypes.bool,
        collapsed: PropTypes.bool.isRequired,
        contentMetadata: ContentMetadataPropType.isRequired,
        editRequests: PropTypes.array,
    };

    static defaultProps = {
        collapseable: false,
        editRequests: []
    };

    constructor(props) {
        super(props);
        this.state = {
            collapsed: props.collapsed
        };
    }

    toggleCollapsed = event => {
        event.preventDefault();
        this.setState({
            collapsed: !this.state.collapsed
        });
    };

    postOnDate = () => {
        const {
            post_state,
            flight_end_date_unix,
            notified_to_post_at,
            content_metadata_id
        } = R.evolve(
            {
                notified_to_post_at: date => (date ? moment.utc(date) : date),
                flight_end_date_unix: date => (date ? moment.unix(date) : date)
            },
            this.props.contentMetadata
        );

        const {PostState} = ENUMS;

        if (
            R.contains(post_state, [
                PostState.ADMIN_INCORRECT_CONTENT,
                PostState.BRAND_INCORRECT_CONTENT,
                PostState.BRAND_INCORRECT_POST,
                PostState.BRAND_REJECTED_CONTENT,
                PostState.DO_NOT_DISTRIBUTE
            ])
        ) {
            return null;
        }

        const postOnDayOf = R.pipe(
            R.cond([
                [R.propSatisfies(R.isNil, 'notified_to_post_at'), R.prop('flight_end_date_unix')],
                [R.T, () => moment.max(flight_end_date_unix, notified_to_post_at)]
            ]),
            m => m.local().format('MM/DD/YYYY')
        )({
            flight_end_date_unix,
            notified_to_post_at
        });

        return (
            <span className="pull-right">
                <span className="date-range">Creator Must Post By {postOnDayOf}</span>
            </span>
        );
    };

    render() {
        const {contentMetadata, editRequests} = this.props;
        const {recent_activity, notes} = contentMetadata;
        const activity_posts = [...recent_activity, ...editRequests];

        const brandNotes = notes ? <ActivityBrandItem brandNotes={notes} /> : '';

        if (this.state.collapsed && this.props.collapseable) {
            const activityCount = activity_posts.length;
            return (
                <div className="activity-feed collapsed" onClick={this.toggleCollapsed}>
                    <div className="activity-feed-header">
                        Activity
                        <div className="activity-count-container pull-right">
                            <div
                                className={`activity-count ${ContentMetadataCommentSourceCssClasses.ops_reject}`}
                            >
                                <div>{activityCount}</div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="activity-feed">
                <div className="activity-feed-header" onClick={this.toggleCollapsed}>
                    <b>Conversation</b>
                    {this.postOnDate()}
                </div>
                {R.map(
                    activity => (
                        <ActivityFeedItem key={activity.id} {...activity} />
                    ),
                    activity_posts
                )}
                {brandNotes}
            </div>
        );
    }
}

export default ActivityFeedList;



// WEBPACK FOOTER //
// ./approval_queues/components/activity_feed/activity_feed_list.js